export default {
      id: "header_recherche-usage",
      viewBox: "0 0 15.23 15",
      url: "../dist/images/" + "sprite.svg#header_recherche-usage",
      toString: function () {
        return this.url;
      }
    }